import { Suspense } from "react";

import { PageSkeleton } from "@stacklet/ui";
import { lazily } from "react-lazily";

import { lazyRouteLoader } from "app/utils/lazyRouteLoader";

import type { PreloadingRouteProps } from "app/utils/lazyRouteLoader";

// Routes.tsx imports this module statically, so it is part of the app shell's
// bundle: the page and its preload module may only be imported dynamically
// here, or the split that lets the loader run ahead of the page's chunk is
// lost.

const { UserDetailsRoute } = lazily(() => import("./UserDetailsRoot"));

/** The /settings/access-control/users/:key index route: see UserDetailsRoot. */
export const userDetailsRoute: PreloadingRouteProps = {
  element: (
    <Suspense fallback={<PageSkeleton />}>
      <UserDetailsRoute />
    </Suspense>
  ),
  loader: lazyRouteLoader({
    load: () =>
      import("./userDetailsPreload").then((module) =>
        module.createUserDetailsLoader(),
      ),
    warm: () => import("./UserDetailsRoot"),
  }),
  // The details page keeps its own query up to date while it is mounted (see
  // useRoutePreloadedQuery), so the loader only runs again when the URL names
  // a different user. The key flows redirect back from routes of their own, so
  // landing on `#api-keys` is a fresh match whose loader always runs.
  shouldRevalidate: ({ currentParams, nextParams }) =>
    currentParams.key !== nextParams.key,
};
